import React, { useState } from "react";
import { Chip, Divider, Grid } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { BtnBack, BtnDelete, BtnDraft, BtnEdit, BtnSend } from "components/Button/ButtonAll";
import { useTicketSoldForm } from "../../hooks/useTicketSold";
import TableSold from "../components/Sold/TableSold";
import TableCompareTicket from "../components/Sold/TableCompareTicket";
import TableMoney from "../components/Sold/TableMoney";
import TableReturnTicket from "../components/Sold/TableReturnTicket";
import { TextBoxItem } from "components/Input/TextBox";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { TextAreaItem } from "components/Input/TextArea";
import moment from "moment";
import { SelectItem } from "components/Input/Select/SelectItem";

export const ProviderSoldTicket = React.createContext(null);


export const TicketSoldForm = () => {
    const {
        statusId,
        isView,
        isEditFlow,
        isDeleteSold,
        objParamPath,
        objMuseum,
        form,
        gotoBack,
        handleSubmitForm,
        option,
        defaultValues,
        getSoldTicketType,
        setObjTotal,
        setObjTotalMoney,
        nUserType,
        lstTotalTicketSell,
        setLstTotalTicketSell,
        OnEditTicketSold,
        OnDeleteTicketSold
    } = useTicketSoldForm();

    const [isreRender, setIsreRender] = useState(false)


    const objProvider = React.useMemo(() => (
        {
            statusId,
            isView,
            form,
            objMuseum,
            defaultValues,
            option,
            isreRender,
            setIsreRender,
            setObjTotal,
            setObjTotalMoney,
            nUserType,
            lstTotalTicketSell,
            setLstTotalTicketSell,
        }
    ), [statusId, isView, form, objMuseum, defaultValues, option, isreRender, setObjTotal, setObjTotalMoney, nUserType, lstTotalTicketSell, setLstTotalTicketSell]);



    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ProviderSoldTicket.Provider
                    value={objProvider}
                >
                    <FormProvider {...form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <DatePickerItem
                                    name={"dSoldTicket"}
                                    id={"dSoldTicket"}
                                    label={`วันที่จำหน่าย`}
                                    fullWidth={true}
                                    required={true}
                                    maxDate={moment()}
                                    disabled={isView || [3, 4].includes(statusId) || !!objParamPath.ParamId}
                                    onChange={(value) => {
                                        if (nUserType !== 1 && form.getValues("nMuseumID")) {
                                            let nMuseum = form.getValues("nMuseumID");
                                            getSoldTicketType(nMuseum, value);
                                        }
                                        else if (nUserType === 1) {
                                            getSoldTicketType(objMuseum.nMuseumID, value);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={9}>
                                {
                                    nUserType === 1 ?
                                        <TextBoxItem
                                            name="sMuseum"
                                            label={"ชื่อพิพิธภัณฑ์"}
                                            maxLength={250}
                                            id={"sMuseum"}
                                            required={true}
                                            type={'text'}
                                            disabled
                                        />
                                        :
                                        <SelectItem
                                            id={"nMuseumID"}
                                            name={"nMuseumID"}
                                            label={`ชื่อพิพิธภัณฑ์`}
                                            required={nUserType !== 1}
                                            options={option.lstMuseum}
                                            disabled={objParamPath.ParamId != null}
                                            onChange={(eValue) => {
                                                let nMuseumId = eValue ? eValue.value : null;
                                                getSoldTicketType(nMuseumId, form.getValues("dSoldTicket"));
                                            }}
                                        />
                                }

                            </Grid>
                            <Grid item xs={12}>
                                <MultipleSelectItem
                                    id={"arrSeller"}
                                    name={"arrSeller"}
                                    label={`ผู้จำหน่าย`}
                                    required={true}
                                    options={option.lstSeller}
                                    disabled={isView || [3, 4].includes(statusId)}
                                    limitTag={4}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={"รายการจำหน่าย"} /></Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableSold />
                            </Grid>
                            <Grid item xs={12}>
                                <TableMoney />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={"รายการคืน"} /></Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableReturnTicket />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={"เปรียบเทียบรายการเบิก"} /></Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableCompareTicket />
                            </Grid>
                            {[3, 4].includes(statusId) && <Grid item xs={12}>
                                <Divider textAlign="left" className="font-weight-500 red">เหตุผลจากการตรวจสอบ</Divider>
                            </Grid>}
                            {[3, 4].includes(statusId) && <Grid item xs={12}>
                                <TextAreaItem
                                    id='sRemarkFlow'
                                    name='sRemarkFlow'
                                    required={false}
                                    disabled
                                    label={"เหตุผล"}
                                    maxLength={250}
                                    placeholder={"เหตุผล"}
                                    row={3}
                                />
                            </Grid>}
                        </Grid>
                    </FormProvider>
                </ProviderSoldTicket.Provider>
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
                {/* Button */}
                <Grid
                    container
                    spacing={2}
                    justifyContent={"space-between"}
                    alignItems={"start"}
                >
                    <Grid item>
                        <BtnBack id={"btnback-ticketsold"} onClick={() => gotoBack()} />
                    </Grid>
                    <Grid item>
                        {isView ?
                            null
                            :
                            <Grid
                                container
                                spacing={2}
                                justifyContent={"end"}
                                alignItems={"start"}
                            >
                                {statusId === 0 && <Grid item>
                                    <BtnDraft
                                        id={"btndraft-ticketsold"}
                                        onClick={() => handleSubmitForm("D")}
                                    />
                                </Grid>}

                                {isDeleteSold && <Grid item>
                                    <BtnDelete
                                        id={"btnDelete-ticketsold"}
                                        txt="ลบการจำหน่ายตั๋ว"
                                        onClick={OnDeleteTicketSold}
                                    />
                                </Grid>}

                                {isEditFlow && <Grid item>
                                    <BtnEdit
                                        id={"btnEdit-ticketsold"}
                                        txt="แก้ไขข้อมูล"
                                        onClick={OnEditTicketSold}
                                    />
                                </Grid>}

                                <Grid item>
                                    <BtnSend
                                        id={"btnsave-ticketsold"}
                                        txt="ยืนยันและส่งตรวจสอบ"
                                        onClick={form.handleSubmit(() => handleSubmitForm("S"))}
                                    />
                                </Grid>
                            </Grid>}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
